import { CardActionArea, Tooltip } from '@mui/material';
import { Fragment } from 'react';
import { Col, Row } from 'react-bootstrap';

const ActionButton = (props) => {
  const { tooltipText, tooltipPlacement, actionMessage, icon, action } =
    props || {};

  return (
    <Fragment>
      {tooltipText ? (
        <Tooltip
          title={tooltipText}
          placement={tooltipPlacement || 'bottom'}
          arrow={true}
        >
          <Col md={2} onClick={action} className="action-button-width">
            <CardActionArea className="action-button">
              <Row className="mt-2 action-icon-center ">{icon}</Row>
              <Row className="mt-2 text-center action-button-message">
                {actionMessage}
              </Row>
            </CardActionArea>
          </Col>
        </Tooltip>
      ) : (
        <Col md={2} onClick={action} className="action-button-width">
          <CardActionArea className="action-button">
            <Row className="mt-2 action-icon-center ">{icon}</Row>
            <Row className="mt-2 text-center action-button-message">
              {actionMessage}
            </Row>
          </CardActionArea>
        </Col>
      )}
    </Fragment>
  );
};

export default ActionButton;
